import styled from "styled-components"

const Taxo = styled.p`
  color: ${(props) => props.theme.c_color_gradients.c_light};
`

const Link = styled.span`
  color: ${(props) => props.theme.a_color_gradients.a_dark};
  font-size: 0.85rem;
  font-weight: bold;
`

export { Taxo, Link }
